export const QUESTION_TYPES_LOAD = 'QUESTION_TYPES_LOAD';
export const QUESTION_TYPES_SAVE = 'QUESTION_TYPES_SAVE';

export const TESTSESSIONQUESTION_LOAD = 'TESTSESSIONQUESTION_LOAD';



// WEBPACK FOOTER //
// ./src/constants.js